// extracted by mini-css-extract-plugin
export default {"container":"RegistrationWizard_container__op9XO","content":"RegistrationWizard_content__uNoyZ"};